<div class="backDrop center white" *ngIf="visibleSubject.asObservable() | async">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h3 class="modal-title text-center">{{this.title}}</h3>
			</div>
			<div class="modal-body">
                <ng-container *ngIf="linkSubject | async as link">
                    <ng-container *ngIf="link.companyId">
                        <al-link-log [link]="link"></al-link-log>
                    </ng-container>
                </ng-container>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-danger" (click)="close()">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
